module.exports = __webpack_public_path__ + "static/img/3.f86aaf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R508B/3.jpg
// module id = 7eVx
// module chunks = 1